import { useMemo } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Select,
  TextField,
  Typography,
  Card,
  CardHeader,
  FormControl,
  DialogActions,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Backdrop,
  LinearProgress,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import RedesignBodyHeader from '../../components/bodyheader/RedesignBodyHeader';
import RedesignBodyHeaderBottom from '../../components/bodyheader/RedesignBodyHeaderBottom';
import Layout from '../../components/layout/Layout';
import { FaList } from 'react-icons/fa';
import FolderIcon from '@mui/icons-material/Folder';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  addContent,
  addWidget,
  checkedSingleContent,
  contentMoveToFolder,
  deleteContent,
  flagContentOff,
  getContentById,
  addContentFromGoogleDrive,
  addContentFromOneDrive,
  unCheckedSignleContent,
  moveMultipleContent,
  closeContentDuplicateError,
  pullContentFromFolder,
  getContent,
  getPlaylistsByContent,
  registerContentDelete,
  closeWidgetSyncPrompt,
  syncWidgetScreens,
} from '../../redux/actions/Content';
import {
  getSplitScreensById,
  deleteSplitScreen,
} from 'src/redux/actions/SplitScreen';
import { setFolderId } from '../../redux/actions/FileFolder';
import All from './components/All';
import Images from './components/Images';
import Videos from './components/Videos';
import {
  addContentInPlaylist,
  playlistFlagOff,
} from '../../redux/actions/Playlist';
import { isYoutubePending } from 'src/utils/youtubeProcessing';
import YoutubeProcessingDialog from 'src/components/selectfilesmodal/YoutubeProcessingDialog';
import AddContentModel from '../../components/addcontent/AddContentModel';
import toast from 'react-hot-toast';
import { useMediaQuery } from 'react-responsive';
import {
  editFolder,
  folderDelete,
  folderFlagOff,
  getFolders,
} from '../../redux/actions/FileFolder';
import Folders from './components/Folders';
import {
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import ConfirmationModel from '../../components/confirmmodel/ConfirmationModel';
import Circularbar from '../../components/circularbar/Circularbar';
import { checkedContent, unCheckedContent } from '../../redux/actions/Content';
import Previewer from './components/Previewer';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import useGoogleDrivePicker from '../../hooks/use-googledrive-picker';
import useOneDrivePicker from '../../hooks/use-onedrive-picker';

import CreateWidgetModel from './components/CreateWidgetModel';
import Widgets from './components/Widgets';

// new

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Stack from '@mui/material/Stack';

//icons

import MoveUpIcon from '@mui/icons-material/MoveUp';
import DeleteIcon from '@mui/icons-material/Delete';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SlowMotionVideoIcon from '@mui/icons-material/SlowMotionVideo';
import ImageIcon from '@mui/icons-material/Image';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

import { useSettings } from 'src/hooks/use-settings';
import { paths } from 'src/paths';
import BreadCrumbs from 'src/components/common/BreadCrumbs';
import ConfirmDeleteDialog from './components/ConfirmDeleteDialog';
import WidgetSyncScreensDialog from './components/WidgetSyncScreensDialog';
import { api } from 'src/api/endpoints';
import RedesignPlayer from '../screen/components/RedesignPlayer';

const components = {
  all: All,
  images: Images,
  videos: Videos,
  widgets: Widgets,
};
function RedesignFile({ socketRef, user }) {
  const { t } = useTranslation();
  const settings = useSettings();

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const handle = useFullScreenHandle();

  const [openGoogelDrivePicker, googleDriveAuth] = useGoogleDrivePicker();
  const [googleDriveFiles, setGoogleDriveFiles] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const { openOneDrivePicker } = useOneDrivePicker();

  const { folderId } = useParams();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('apps')) {
      setOpenWidget(true);
      // navigate(paths.files.index);
    }
  }, [location]);

  useEffect(() => {
    dispatch(setFolderId(folderId || 'root'));
  }, [folderId]);

  const {
    content,
    isDeleting,
    isDeleted,
    isContentAddedInContent,
    isContentAdding,
    uploadFailedError,
    uploadFailedErrorMessage,
    contentDuplicateError,
    widgetSyncPromptOpen,
    widgetSyncContentId,
  } = useSelector((state) => state.Content);
  const { splitScreen, splitScreens, isSplitScreenAdded } = useSelector(
    (state) => state.SplitScreen,
  );
  const { screens } = useSelector((state) => state.Screen);
  const { playlists, isContentAdded } = useSelector((state) => state.Playlist);
  const {
    currentFolder,
    allFolders,
    userFolders,
    contentFolders,
    files,
    isFolderCreated,
    isFolderDeleted,
    contentsCount,
    duplicateNamesError,
    folderDuplicateNamesError,
    contentMoveToFolderError,
    contentPullFromFolderError,
    widgetEditError,
  } = useSelector(
    (state) => ({
      currentFolder: state.FileFolder.currentFolder,
      userFolders: state.FileFolder.userFolders.filter(
        (f) =>
          f.parent === state.FileFolder.currentFolder &&
          f?.folderFor === 'content',
      ),
      allFolders: state.FileFolder.userFolders,
      contentFolders: state.FileFolder.userFolders.filter(
        (f) => f?.folderFor === 'content',
      ),
      // files: state.Content.content,
      files: state.Content.content.filter(
        (c) =>
          c.folders?.includes(state.FileFolder.currentFolder) ||
          state.FileFolder.currentFolder == 'root',
      ),
      isFolderCreated: state.FileFolder.isFolderCreated,
      isFolderDeleted: state.FileFolder.isFolderDeleted,
      contentsCount: state.Content.contentsCount,
      duplicateNamesError: state.Content.duplicateNamesError,
      folderDuplicateNamesError: state.FileFolder.folderDuplicateNamesError,
      contentMoveToFolderError: state.Content.contentMoveToFolderError,
      contentPullFromFolderError: state.Content.contentPullFromFolderError,
      widgetEditError: state.Content.widgetEditError,
    }),
    shallowEqual,
  );

  console.log(currentFolder);

  // console.log(currentFolder)

  const [openPlaylist, setOpenPlaylist] = useState(false);
  const [ytPendingNames, setYtPendingNames] = useState([]);
  const [playlistId, setPlaylistId] = useState('');
  const [ids, setIds] = useState('');
  const [folderVal, setFolderVal] = useState('');
  const [contentObj, setContentObj] = useState({});
  const [search, setSearch] = useState('');
  const [browse, setBrowse] = useState(false);
  const [openMoveModel, setOpenMoveModel] = useState(false);
  const [openBulkMoveModel, setOpenBulkMoveModel] = useState(false);
  const [file, setFile] = useState([]);
  const [key, setKey] = useState('all');
  const [openCreateModel, setOpenCreateModel] = useState(false);
  const [openFolderEditModel, setOpenFolderEditModel] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [viewValue, setViewValue] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);
  const [deleteUsage, setDeleteUsage] = useState({
    playlists: [],
    folders: [],
    screens: [],
  });
  const [previewContentUrl, setPreviewContentUrl] = useState({
    url: '',
    type: '',
  });
  const [openPreviewContentModel, setOpenPreviewContentModel] = useState(false);
  const [openWidget, setOpenWidget] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [datas, setData] = useState([]);
  const [currentE, setCurrentE] = useState(null);
  const [currentFilesPage, setCurrentFilesPage] = useState(0);
  const [isFoldersDialogOpen, setIsFoldersDialogOpen] = useState({
    open: false,
    folders: [],
  });
  const [isPlaylistsDialogOpen, setIsPlaylistsDialogOpen] = useState({
    open: false,
    id: '',
  });
  const [progressBars, setProgressBars] = useState({ open: false, bars: [] });
  const [uploadState, setUploadState] = useState({
    open: false,
    total: 0,
    done: 0,
    currentName: '',
    currentProgress: 0,
    failed: [],
    finished: false,
  });
  const [deleteProgressBar, setDeleteProgressBar] = useState({
    open: false,
    progress: 0,
    filesCount: 1,
  });
  const [currentContentPreview, setCurrentContentPreview] = useState(null);
  const [isSyncingWidgetScreens, setIsSyncingWidgetScreens] = useState(false);
  const Component = components[key];

  const currentContentPreviewPlaylist = useMemo(() => {
    if (!currentContentPreview) {
      return null;
    }

    const type = (currentContentPreview.type || '').toLowerCase();
    const resolvedWidgetUrl =
      currentContentPreview?.widget?.url ||
      currentContentPreview?.widget?.content_path ||
      '';
    const resolvedUrl =
      type === 'widget'
        ? resolvedWidgetUrl || currentContentPreview.url || ''
        : currentContentPreview.url || currentContentPreview.content_path || '';

    const parsedPreviewContent = {
      ...currentContentPreview,
      _id: currentContentPreview._id || currentContentPreview.id,
      id: currentContentPreview.id || currentContentPreview._id,
      type,
      url: resolvedUrl,
    };

    return {
      content: [parsedPreviewContent],
    };
  }, [currentContentPreview]);

  const onPreview_content = (previewContentObject) => {
    // console.log("defasc", previewContentObject)
    setPreviewContentUrl({
      content: [
        {
          url: previewContentObject.url,
          type: previewContentObject.contentType,
          embed: previewContentObject.embed,
          widget: previewContentObject.widget,
        },
      ],
    });
    // setOpenPreviewContentModel(true);
    // handle.enter();
  };

  const [currentFilesQuery, setCurrentFilesQuery] = useState({
    name: '',
    type: '',
    page: 0,
    sortType: '',
    sortDirection: '',
    folder: '',
  });

  const currentFilesQueryRef = useRef(currentFilesQuery);

  const refreshCurrentFiles = () => {
    const query = currentFilesQueryRef.current;
    dispatch(
      getContent(
        query.page,
        query.name,
        query.sortType,
        query.sortDirection,
        query.type == 'allNotSplit' ? '' : query.type,
        query.folder == 'root' ? '' : query.folder,
      ),
    );
  };

  const upsertProgressBar = (jobId, filename, progress) => {
    setProgressBars((prev) => {
      const bars = [...prev.bars];
      const index = bars.findIndex((item) => item.b2filename === jobId);

      if (index >= 0) {
        bars[index] = {
          ...bars[index],
          progress,
          filename: filename || bars[index].filename,
        };
      } else {
        bars.push({
          b2filename: jobId,
          filename,
          progress,
        });
      }

      return {
        open: bars.length > 0,
        bars,
      };
    });
  };

  const removeProgressBar = (jobId) => {
    setProgressBars((prev) => {
      const bars = prev.bars.filter((item) => item.b2filename !== jobId);
      return {
        open: bars.length > 0,
        bars,
      };
    });
  };

  // ---- useEffects ----
  // useEffect(() => {
  //   if (user?.isMember) {
  //     dispatch(getSplitScreensById(user?.user?._id));
  //   } else {
  //     dispatch(getSplitScreensById(user?._id));
  //   }
  // }, [user]);

  useEffect(() => {
    dispatch(getFolders(user?._id));
  }, [refreshData]);

  useEffect(() => {
    if (isContentAdded) {
      toast.success(t('views.redesignFile.contentAdded'));
      const s = screens.find((c) => c?.playlist?._id === playlistId);
      console.log(s);
      if (s !== undefined || s !== null) {
        emitOnAddContentInPlaylist(s?.mac);
      }
      dispatch(playlistFlagOff());
    }
    if (isFolderCreated) {
      toast.success(t('views.redesignFile.folderCreated'));
      dispatch(folderFlagOff());
    }
    if (isFolderDeleted) {
      toast.success(t('views.redesignFile.folderDeleted'));
      dispatch(folderFlagOff());
    }
    if (isContentAddedInContent) {
      // toast.success(t("views.redesignFile.contentAddedSuccessfully"));
      dispatch(flagContentOff());
    }
    if (isDeleted) {
      // toast.success(t("views.redesignFile.contentDeletedSuccessfully"));
      dispatch(flagContentOff());
    }
  }, [
    isContentAdded,
    isFolderCreated,
    isFolderDeleted,
    isContentAddedInContent,
    isDeleted,
  ]);

  useEffect(() => {
    document.addEventListener('fullscreenchange', function (e) {
      if (!document.fullscreenElement) {
        setPreviewContentUrl(null);
        setOpenPreviewContentModel(false);
      }
    });
  }, []);

  const emitOnAddContentInPlaylist = (mac) => {
    if (socketRef) {
      socketRef?.current.emit('content_added', { detail: { mac: mac } });
    }
  };

  useEffect(() => {
    if (duplicateNamesError) {
      toast.error(t('views.redesignFile.fileAlreadyExistsName'));
    }
  }, [duplicateNamesError]);

  useEffect(() => {
    if (folderDuplicateNamesError) {
      toast.error(t('views.folder.folderSameNameError'));
    }
  }, [folderDuplicateNamesError]);

  useEffect(() => {
    if (contentMoveToFolderError) {
      switch (contentMoveToFolderError) {
        case 'noContentOrNoPermission':
          toast.error(t('views.redesignFile.cantFindContentOrNoPermission'));
          break;
        case 'noFolderOrNoPermission':
          toast.error(t('views.redesignFile.noFolderOrNoPermission'));
          break;
        default:
          toast.error(contentMoveToFolderError);
          break;
      }
    }
  }, [contentMoveToFolderError]);

  useEffect(() => {
    if (widgetEditError) {
      toast.error(t('views.redesignFile.widgetEditError'));
    }
  }, [widgetEditError]);

  useEffect(() => {
    if (contentPullFromFolderError) {
      if (contentPullFromFolderError == 'noContentOrNoPermission') {
        toast.error(t('views.redesignFile.cantFindContentOrNoPermission'));
      } else {
        toast.error(t('views.redesignFile.pullingContentFromFolderError'));
      }
    }
  }, [contentPullFromFolderError]);

  const onAddPlaylist = (contentObject) => {
    if (isYoutubePending(contentObject)) {
      setYtPendingNames([contentObject.name]);
      return;
    }
    setContentObj({ ...contentObject });
    setOpenPlaylist(true);
  };

  const addInPlaylist = () => {
    // console.log('from file add in playlist=>',contentObj)
    dispatch(addContentInPlaylist({ id: playlistId, value: contentObj.id }));
    setOpenPlaylist(false);
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = function () {
        window.URL.revokeObjectURL(video.src);
        resolve(Math.round(video.duration * 1000)); // Convert to milliseconds and round
      };

      video.onerror = function () {
        reject('An error occurred while loading video metadata');
      };

      video.src = URL.createObjectURL(file);
    });
  };

  const putFileToS3 = (url, file, onProgress) =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          onProgress(Math.round((event.loaded / event.total) * 100));
        }
      };
      xhr.onload = () =>
        xhr.status >= 200 && xhr.status < 300
          ? resolve()
          : reject(new Error(`S3 upload failed (${xhr.status})`));
      xhr.onerror = () => reject(new Error('Network error during upload'));
      xhr.send(file);
    });

  const getUploadErrorMessage = (error) => {
    const responseData = error?.response?.data;
    if (responseData === 'ExistingContentWithSameName') {
      return t('views.redesignFile.fileAlreadyExistsName');
    }
    if (typeof responseData === 'string') {
      return responseData;
    }
    return error?.message || 'Error while uploading file';
  };

  const uploadFilesDirectly = async (fileArray, durations) => {
    const failed = [];
    const total = fileArray.length;
    setUploadState({
      open: true,
      total,
      done: 0,
      currentName: '',
      currentProgress: 0,
      failed: [],
      finished: false,
    });

    for (let i = 0; i < total; i++) {
      const file = fileArray[i];
      setUploadState((prev) => ({
        ...prev,
        currentName: file.name,
        currentProgress: 0,
      }));

      try {
        const { data: presigned } = await api.post(
          '/content/getpresignedurltoupload',
          {
            fileName: file.name,
            fileType: file.type,
            fileSize: file.size,
            filesCount: total,
          },
        );

        await putFileToS3(presigned.url, file, (percent) =>
          setUploadState((prev) => ({ ...prev, currentProgress: percent })),
        );

        await api.post('/content/registerFile', {
          originalName: file.name,
          path: presigned.filename,
          type: file.type.split('/')[0],
          duration: durations[i],
          folderId: currentFolder,
        });
      } catch (error) {
        failed.push({ name: file.name, reason: getUploadErrorMessage(error) });
      }

      setUploadState((prev) => ({
        ...prev,
        done: prev.done + 1,
        failed: [...failed],
      }));
    }

    refreshCurrentFiles();
    setUploadState((prev) => ({
      ...prev,
      open: failed.length > 0,
      finished: true,
    }));
  };

  const handleFileUpload = async (force) => {
    console.log(currentE);
    if (currentE) {
      const file = currentE.files;
      const fileArray = Array.from(file);

      //   if(fileArray.length < 5) {
      let successCounter = 0;
      fileArray.forEach((f) => {
        if (
          f.type.split('/')[0] == 'image' ||
          f.type.split('/')[0] == 'video'
        ) {
          successCounter = successCounter + 1;
        }
      });
      if (successCounter == fileArray.length) {
        const maxFiles = Number(
          user?.plan?.planFeatures?.find(
            (pf) => pf.slug == 'files_one_time_upload_limit',
          )?.value,
        );
        if (maxFiles && fileArray.length > maxFiles) {
          toast.error(
            t('views.redesignFile.cantUploadMoreFilesErr').replace(
              '{{maxFiles}}',
              maxFiles,
            ),
          );
          return;
        }
        setProgressBars({ open: false, bars: [] });
        const durations = await Promise.all(
          fileArray.map(async (singleFile) => {
            if (singleFile.type.startsWith('video/')) {
              try {
                return await getVideoDuration(singleFile);
              } catch (error) {
                console.error(
                  `Error getting duration for ${singleFile.name}:`,
                  error,
                );
                return 10000;
              }
            }
            return 10000;
          }),
        );

        setBrowse(false);
        await uploadFilesDirectly(fileArray, durations);
      } else {
        toast.error(t('views.redesignFile.mustBePhotoOrVideo'));
      }
      //   }else{
      //     toast.error(t("views.redesignFile.cantUploadMoreFiles"))
      //   }
    }
  };

  console.log(progressBars);

  const fileUpload = async (e) => {
    e?.preventDefault();

    setCurrentE(e.target);
  };

  // const fileUploadDragDrop = async (e) => {
  //   console.log(e.dataTransfer)
  //   e.preventDefault();

  //   setCurrentE(e.dataTransfer)
  // };

  useEffect(() => {
    handleFileUpload();
  }, [currentE]);

  useEffect(() => {
    currentFilesQueryRef.current = currentFilesQuery;
  }, [currentFilesQuery]);

  useEffect(() => {
    const socket = socketRef?.current;
    const userId = user?.isMember ? user?.user?._id : user?._id;

    if (!socket || !userId) {
      return;
    }

    socket.emit('join-user', { userId });

    const onUploadQueued = ({ jobId, fileName }) => {
      upsertProgressBar(jobId, fileName, 0);
    };

    const onUploadStarted = ({ jobId, fileName, progress }) => {
      upsertProgressBar(jobId, fileName, progress || 1);
    };

    const onUploadProgress = ({ jobId, fileName, progress }) => {
      upsertProgressBar(jobId, fileName, progress || 0);
    };

    const onUploadCompleted = ({ jobId }) => {
      upsertProgressBar(jobId, '', 100);
      setTimeout(() => {
        removeProgressBar(jobId);
      }, 200);
      refreshCurrentFiles();
    };

    const onUploadFailed = ({ jobId, error }) => {
      removeProgressBar(jobId);
      toast.error(error || 'Error while uploading file');
    };

    socket.on('upload:queued', onUploadQueued);
    socket.on('upload:started', onUploadStarted);
    socket.on('upload:progress', onUploadProgress);
    socket.on('upload:completed', onUploadCompleted);
    socket.on('upload:failed', onUploadFailed);

    return () => {
      socket.off('upload:queued', onUploadQueued);
      socket.off('upload:started', onUploadStarted);
      socket.off('upload:progress', onUploadProgress);
      socket.off('upload:completed', onUploadCompleted);
      socket.off('upload:failed', onUploadFailed);
    };
  }, [socketRef, user, dispatch, t]);

  const handleAddWidget = async (widgetObj) => {
    return await dispatch(addWidget({ ...widgetObj, origin: 'contentWidget' }));
    // console.log('res', result)
  };

  const onDelete = async (id) => {
    const usage = await dispatch(getPlaylistsByContent(id));
    if (!usage) {
      return;
    }

    const file = filteredFiles().find((item) => item.id === id);
    setDeleteIds([id]);
    setDeleteUsage({
      ...usage,
      folders: file?.foldersData || [],
    });
    setOpenDeleteModel(true);
  };

  const onConfirmDeleteFile = () => {
    setOpenDeleteModel(false);
    if (deleteIds.length === 1) {
      dispatch(deleteContent(deleteIds[0]));
    } else if (deleteIds.length > 1) {
      delContent(deleteIds);
    }
    setDeleteIds([]);
  };

  const handlePullManyContentsFromFolder = () => {
    const _checkedList = content.filter((c) => c.checked === true);

    for (const item of _checkedList) {
      dispatch(pullContentFromFolder(item.id, currentFolder));
    }
  };

  const onMove = (id) => {
    setIds(id);
    setOpenMoveModel(true);
  };

  const moveOnFolder = () => {
    setOpenMoveModel(false);
    setFolderVal('');
    dispatch(contentMoveToFolder({ id: ids, folderId: folderVal }));
    // toast.success("Successfully moved content to folder")
  };

  const handleContentsPageChange = (mode, type) => {
    if (mode == 'reset') {
      setCurrentFilesPage(0);
    } else {
      if (type == '+1') {
        if (currentFilesQuery.page < Math.floor(contentsCount / 30)) {
          setCurrentFilesQuery({
            ...currentFilesQuery,
            page: currentFilesQuery.page + 1,
          });
        }
      } else {
        if (currentFilesQuery.page > 0) {
          setCurrentFilesQuery({
            ...currentFilesQuery,
            page: currentFilesQuery.page - 1,
          });
        }
      }
    }
  };

  const checkFilesPlaylists = (id) => {
    if (filteredFiles().find((f) => f.id == id)) {
      if (!filteredFiles().find((f) => f.id == id).playlists) {
        dispatch(getPlaylistsByContent(id));
      }
    }
    setIsPlaylistsDialogOpen({ open: true, id: id });
  };

  useEffect(() => {
    dispatch(
      getContent(
        currentFilesQuery.page,
        currentFilesQuery.name,
        currentFilesQuery.sortType,
        currentFilesQuery.sortDirection,
        currentFilesQuery.type == 'allNotSplit' ? '' : currentFilesQuery.type,
        currentFilesQuery.folder == 'root' ? '' : currentFilesQuery.folder,
      ),
    );
    // console.log(currentFilesQuery)
  }, [currentFilesQuery]);

  useEffect(() => {
    console.log('currentFolder', currentFolder);
    setCurrentFilesQuery({
      ...currentFilesQuery,
      page: 0,
      name: '',
      type: '',
      folder: currentFolder,
    });
  }, [currentFolder]);

  const moveOnFolderBulk = async () => {
    setOpenBulkMoveModel(false);
    setFolderVal('');

    const _checkedList = content.filter((c) => c.checked === true);

    let moveErrors = 0;

    for (const item of _checkedList) {
      try {
        await dispatch(
          contentMoveToFolder({ id: item.id, folderId: folderVal }),
        );
      } catch (error) {
        console.error(`Error moving item ${item.id}:`, error);
        moveErrors++;
      }
    }

    if (moveErrors === 0) {
      toast.success(t('views.redesignFile.allContentMovedSuccessfully'));
    } else if (moveErrors < _checkedList.length) {
      toast.warning(
        t('views.redesignFile.someContentFailedToMove', { count: moveErrors }),
      );
    } else {
      toast.error(t('views.redesignFile.allContentFailedToMove'));
    }

    setIsChecked(false);
  };

  const onFolderDelete = (id) => {
    const childrenfiles = content.filter((c) => c.folderId === id);
    const childrenfolder = allFolders.filter((f) => f.parent === id);
    // console.log(childrenfolder);
    if (childrenfiles.length == 0 && childrenfolder.length == 0) {
      setIds(id);
      setOpenCreateModel(true);
    } else {
      toast.success(t('views.redesignFile.folderContainsContent'));
    }
  };

  const onConfirm = () => {
    setOpenCreateModel(false);
    dispatch(folderDelete(ids));
  };

  const onFolderEdit = (id, name) => {
    setIds(id);
    setFolderName(name);
    setOpenFolderEditModel(true);
  };

  const onConfirmFolderEdit = () => {
    setOpenFolderEditModel(false);

    const isEmpty = folderName === '';
    const isAvailable = userFolders.find(
      (f) => f.name.toLocaleUpperCase() === folderName.toLocaleUpperCase(),
    );

    if (isEmpty) {
      toast.error(t('views.redesignFile.enterFolderName'));
    } else if (isAvailable) {
      toast.success(t('views.redesignFile.folderAlreadyAvailable'));
    } else {
      dispatch(editFolder(ids, folderName));
    }
  };

  const checkIfSelected = () => {
    if (content.some((c) => c.checked === true)) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  };

  const onCheckedContent = () => {
    //dispatch(checkedContent(currentFolder));
    setIsCheckedAll(true);
    checkIfSelected();
  };
  const onUncheckedContent = () => {
    dispatch(unCheckedContent(currentFolder));
    setIsCheckedAll(false);
    checkIfSelected();
  };
  const onCheckedSingleContent = (id) => {
    dispatch(checkedSingleContent(id));
    checkIfSelected();
  };

  const onUncheckedSingleContent = (id) => {
    dispatch(unCheckedSignleContent(id));
    checkIfSelected();
  };

  const onGetCheckedContent = async () => {
    const _checkedList = content.filter((c) => c.checked === true);
    if (_checkedList.length === 0) {
      return;
    }

    const usages = await Promise.all(
      _checkedList.map((item) => dispatch(getPlaylistsByContent(item.id))),
    );
    if (usages.some((usage) => !usage)) {
      return;
    }

    const selectedFiles = _checkedList.map((item) =>
      filteredFiles().find((file) => file.id === item.id),
    );
    const uniqueById = (items) =>
      [...new Map(items.map((item) => [String(item._id || item.id), item])).values()];

    setDeleteIds(_checkedList.map((item) => item.id));
    setDeleteUsage({
      playlists: uniqueById(usages.flatMap((usage) => usage.playlists)),
      screens: uniqueById(usages.flatMap((usage) => usage.screens)),
      folders: uniqueById(
        selectedFiles.flatMap((file) => file?.foldersData || []),
      ),
    });
    setOpenDeleteModel(true);
  };

  const onMoveCheckedContent = () => {
    setOpenBulkMoveModel(true);
  };

  const delContent = async (idsArr) => {
    setDeleteProgressBar({ ...deleteProgressBar, open: true });
    let counter = 0;
    for await (const delId of idsArr) {
      counter = counter + 1;
      try {
        const { status, data } = await api.patch(`/content/delete/${delId}`);
        if (status == 201) {
          dispatch(registerContentDelete(delId));
          setDeleteProgressBar({
            open: true,
            progress: counter,
            filesCount: idsArr.length,
          });
        }
      } catch (err) {
        setDeleteProgressBar({
          open: true,
          progress: counter,
          filesCount: idsArr.length,
        });
      }
      if (counter == idsArr.length) {
        setDeleteProgressBar({ open: false, progress: 0, filesCount: 1 });
      }
    }
    toast.success(t('views.redesignFile.filesDeletedSuccess'));
  };

  const onGoogleDrive = () => {
    setGoogleDriveFiles([]);
    openGoogelDrivePicker({
      appId: process.env.REACT_APP_GOOGLE_APP_ID,
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      developerKey: process.env.REACT_APP_GOOGLE_DEVELOPER_KEY,
      viewId: 'DOCS_IMAGES_AND_VIDEOS',
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      callbackFunction: (data) => {
        if (data.action === 'loaded') {
          setBrowse(false);
        }
        if (data.action === 'cancel') {
          console.log('User clicked cancel/close button');
        }
        if (data.action === 'picked') {
          setGoogleDriveFiles(
            data.docs.filter((f) => f.type == 'photo' || f.type == 'video'),
          );
        }
      },
    });
  };

  useEffect(() => {
    if (!googleDriveAuth || !googleDriveFiles || !googleDriveFiles?.length)
      return;

    const userData = {
      user: user.isMember ? user?.user._id : user._id,
      subuser: user.isMember ? user?.user._id : user._id,
      role: user.isMember ? user?.role.split('-')[0] : user?.role,
      folderId: currentFolder,
    };

    console.log('Upload GoogleDrive', googleDriveFiles, googleDriveAuth);

    dispatch(
      addContentFromGoogleDrive({
        files: googleDriveFiles,
        auth: googleDriveAuth,
        ...userData,
      }),
    );
  }, [googleDriveAuth, googleDriveFiles]);

  const normaliseProgressValue = (value, max) => (value * 100) / max;

  const onDropboxFiles = (files) => {
    let objFiles = [];
    files.forEach((f) => {
      objFiles.push({
        id: f.id,
        name: f.name,
        type: f.link.substring(f.link.lastIndexOf('.') + 1).split('?')[0],
        url: f.link.replace('?dl=0', '?dl=1'),
        embed: 'embed',
        role: user?.role,
        user: user?._id,
        subuser: user?._id,
        folderId: currentFolder,
      });
    });
    //dispatch(getContentFromGoogleDrive(objFiles))
  };

  const handleOpenFoldersDataDialog = (folders) => {
    setIsFoldersDialogOpen({ open: true, folders: folders });
  };

  const onOneDrive = () => {
    const userData = {
      user: user.isMember ? user?.user._id : user._id,
      subuser: user.isMember ? user?.user._id : user._id,
      role: user.isMember ? user?.role.split('-')[0] : user?.role,
      folderId: currentFolder,
    };

    openOneDrivePicker({
      onFilePick: (file) => {
        dispatch(
          addContentFromOneDrive({
            ...file,
            ...userData,
          }),
        );
      },
    });
    setBrowse(false);
  };

  const onSearchBarChange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  const [searchInput, setSearchInput] = useState('');

  const filteredFiles = () => {
    const updated_split = splitScreens.map((screen) => {
      if (screen?.createdAt && screen?.orientation) return screen;
    });

    console.log('UPDATED SPLIT SCREEN --------- ', updated_split);
    console.log('IPDATED FILES --------- ', files);
    const filesWithFoldersData = files.map((f) => {
      const foldersData = [];
      f.folders.forEach((fld) => {
        if (allFolders.find((ufld) => ufld._id == fld)) {
          foldersData.push({
            name: allFolders.find((ufld) => ufld._id == fld)?.name,
            id: fld,
          });
        }
      });
      return {
        ...f,
        foldersData,
      };
    });
    const updated_files = [...filesWithFoldersData, ...updated_split];
    // console.log("UPDATED FILES", updated_files);
    return updated_files.filter((el) => {
      if (searchInput === '') {
        return el;
      } else {
        if (el.name === undefined) {
        }
        return el.name.toLowerCase().includes(searchInput);
      }
    });
  };

  const isMobile = useMediaQuery({ query: '(max-width: 786px)' });

  return (
    <>
      <Layout
        title={t('views.redesignFile.files')}
        user={user}
        playlistAddBtn={false}
        position={'relative'}
      >
        {isContentAdding && (
          <>
            <Box
              sx={{
                // '*::-webkit-scrollbar': { display: 'none' },
                // '-ms-overflow-style': 'none',
                // 'scrollbar-width': 'none',
                // overflow: 'hidden !important',
                height: '100vh',
                width: '100vw',
                position: 'absolute',
                top: 0,
                // left: 0,
                bottom: 0,
                right: 0,
                zIndex: 10000000000000,
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Circularbar height={'150px'} width={'150px'} />
            </Box>
          </>
        )}
        {isDeleting && (
          <>
            <Box
              sx={{
                height: '100vh',
                width: '100vw',
                position: 'absolute',
                top: 0,
                // left: 0,
                bottom: 0,
                right: 0,
                zIndex: 10000000000000,
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Circularbar height={'150px'} width={'150px'} />
            </Box>
          </>
        )}

        <Backdrop
          sx={(theme) => ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 10,
            flexDirection: 'column',
          })}
          open={uploadState.open}
        >
          <Typography variant='h5' mb={3}>
            {uploadState.finished ? 'Upload finished' : 'Uploading...'}
          </Typography>
          {!uploadState.finished && (
            <Box sx={{ width: '60%' }}>
              <LinearProgress
                variant='determinate'
                value={
                  uploadState.total > 1
                    ? Math.round(
                        ((uploadState.done +
                          uploadState.currentProgress / 100) /
                          uploadState.total) *
                          100,
                      )
                    : uploadState.currentProgress
                }
              />
              <Typography variant='subtitle1' mt={2} textAlign='center'>
                {uploadState.total > 1
                  ? `${uploadState.done} / ${uploadState.total}`
                  : `${uploadState.currentProgress}%`}
              </Typography>
              {uploadState.total > 1 && (
                <Typography
                  variant='body2'
                  textAlign='center'
                  noWrap
                  title={uploadState.currentName}
                >
                  {uploadState.currentName}
                </Typography>
              )}
            </Box>
          )}
          {uploadState.failed.length > 0 && (
            <Box
              sx={{
                mt: 3,
                p: 2,
                width: '60%',
                maxHeight: '30vh',
                overflowY: 'auto',
                bgcolor: 'background.paper',
                color: 'error.main',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'error.main',
              }}
            >
              <Typography variant='subtitle1' fontWeight='bold'>
                {`Failed to upload (${uploadState.failed.length}):`}
              </Typography>
              {uploadState.failed.map((f, idx) => (
                <Typography variant='body2' key={`${f.name}-${idx}`}>
                  {`${f.name} - ${f.reason}`}
                </Typography>
              ))}
            </Box>
          )}
          {uploadState.finished && (
            <Button
              sx={{ mt: 3 }}
              variant='contained'
              onClick={() =>
                setUploadState((prev) => ({ ...prev, open: false }))
              }
            >
              Close
            </Button>
          )}
        </Backdrop>

        <Backdrop
          open={progressBars.open}
          sx={(theme) => ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 10,
            flexDirection: 'column',
          })}
        >
          <Typography variant='h5' mb={3}>
            Uploading...
          </Typography>
          {progressBars.bars.map((pb) => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  width: '100%',
                  mt: 4,
                }}
                key={pb.b2filename}
              >
                <Box sx={{ width: '80%', mb: 2 }}>
                  <LinearProgress variant='determinate' value={pb.progress} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                  <Typography variant='subtitle1'>
                    {pb.filename}
                    &nbsp; &nbsp;
                    {`${pb.progress}%`}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Backdrop>

        <Backdrop
          open={deleteProgressBar.open}
          sx={(theme) => ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 10,
            flexDirection: 'column',
          })}
        >
          <Typography variant='h5' mb={3}>
            {t('views.redesignFile.fileDeletionProgress')}
          </Typography>
          <Box sx={{ width: '60%', mr: 1 }}>
            <LinearProgress
              variant='determinate'
              value={normaliseProgressValue(
                deleteProgressBar.progress,
                deleteProgressBar.filesCount,
              )}
            />
          </Box>
          <Box sx={{ minWidth: 35, mt: 3 }}>
            <Typography variant='subtitle1'>
              {`${deleteProgressBar.progress} / ${deleteProgressBar.filesCount}`}
            </Typography>
          </Box>
        </Backdrop>

        <Box component='main' sx={{ flexGrow: 1, py: 2 }}>
          <Container maxWidth={settings.stretch ? false : 'xl'}>
            <Grid container spacing={{ xs: 3, lg: 4 }}>
              {/* <Grid xs={12}>
                <Stack direction="row" justifyContent="space-between" spacing={4}>
                  <div>
                    <Typography variant="h4">File Manager</Typography>
                  </div>
                </Stack>
              </Grid> */}

              <Box
                sx={{
                  display: 'flex',
                  minWidth: '100%',
                  flexDirection: { md: 'row', xs: 'column-reverse' },
                }}
              >
                {/* left column */}
                <Grid xs={12} md={9}>
                  <Stack spacing={{ xs: 3, lg: 4 }}>
                    {/* <BreadCrumbs title={t("layout.sidebar.files")} /> */}
                    <RedesignBodyHeader
                      user={user}
                      view={viewValue}
                      onViewChange={() => setViewValue(!viewValue)}
                      onAddPlaylist={onAddPlaylist}
                      onMove={onMove}
                      onCheckedContent={onCheckedContent}
                      onUncheckedContent={onUncheckedContent}
                      onGetCheckedContent={onGetCheckedContent}
                      isChecked={isChecked}
                      onSearchBarChange={onSearchBarChange}
                      setCurrentFilesQuery={setCurrentFilesQuery}
                      currentFilesQuery={currentFilesQuery}
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '10px',
                        flexWrap: 'wrap',
                        margin: '20px 0 10px 0',
                      }}
                    >
                      {userFolders.map((folder, index) => {
                        return (
                          <>
                            <Folders
                              key={index}
                              folder={folder}
                              onFolderDelete={onFolderDelete}
                              onFolderEdit={onFolderEdit}
                              setCurrentFilesQuery={setCurrentFilesQuery}
                              currentFilesQuery={currentFilesQuery}
                            />
                          </>
                        );
                      })}
                    </Box>
                    <RedesignBodyHeaderBottom
                      user={user}
                      onCheckedContent={onCheckedContent}
                      onUncheckedContent={onUncheckedContent}
                      onGetCheckedContent={onGetCheckedContent}
                      onMoveCheckedContent={onMoveCheckedContent}
                      isChecked={isChecked}
                      isCheckedAll={isCheckedAll}
                      currentFolder={currentFolder}
                      handlePullManyContentsFromFolder={
                        handlePullManyContentsFromFolder
                      }
                    />
                    <Box sx={{ marginTop: '0px !important' }}>
                      <Component
                        setRefreshData={setRefreshData}
                        refreshCurrentFiles={refreshCurrentFiles}
                        content={filteredFiles()}
                        onAddPlaylist={onAddPlaylist}
                        onPushScreen={(contentObject) =>
                          console.log('----- TEST T', contentObject)
                        }
                        onDelete={onDelete}
                        onMove={onMove}
                        onPreview={onPreview_content}
                        view={viewValue}
                        onCheckedSingleContent={onCheckedSingleContent}
                        onUncheckedSingleContent={onUncheckedSingleContent}
                        handleSelectAll={isCheckedAll}
                        onUncheckedContent={onUncheckedContent}
                        handleOpenFoldersDataDialog={
                          handleOpenFoldersDataDialog
                        }
                        checkFilesPlaylists={checkFilesPlaylists}
                        setCurrentContentPreview={setCurrentContentPreview}
                      />
                      <Divider />
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          width: '100%',
                          gap: '10px',
                          alignItems: 'center',
                          mt: 2,
                        }}
                      >
                        <IconButton
                          onClick={() =>
                            handleContentsPageChange('change', '-1')
                          }
                        >
                          <ArrowBackIosNewIcon />
                        </IconButton>
                        <Typography>
                          {currentFilesQuery.page + 1}/
                          {Math.floor(contentsCount / 30) + 1}
                        </Typography>
                        <IconButton
                          onClick={() =>
                            handleContentsPageChange('change', '+1')
                          }
                        >
                          <ArrowForwardIosIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  </Stack>
                </Grid>

                {/* right column */}
                <Grid xs={12} md={3}>
                  <Card sx={{ p: 2 }}>
                    {/* <CardHeader sx={{ padding: "12px 12px 24px 12px" }} title="Upload files" /> */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: '10px',
                      }}
                    >
                      <Button
                        size={'large'}
                        variant={'contained'}
                        onClick={() => setBrowse(true)}
                        startIcon={<FileUploadIcon />}
                        disable={
                          user.isMember
                            ? user?.previlliages?.content?.canCreate
                              ? false
                              : true
                            : false
                        }
                      >
                        {t('views.redesignFile.uploadFiles')}
                      </Button>
                      <Button
                        size={'large'}
                        variant={'contained'}
                        onClick={() => setOpenWidget(true)}
                        disable={
                          user.isMember
                            ? user?.previlliages?.content?.canCreate
                              ? false
                              : true
                            : false
                        }
                      >
                        {t('views.redesignFile.apps')}
                      </Button>
                      <Button size={'large'} variant={'contained'} disabled>
                        {t('views.redesignFile.templates')}
                      </Button>
                    </Box>
                    <Box>
                      <CardHeader
                        sx={{ padding: '24px 12px 12px 12px' }}
                        title={t('views.redesignFile.type')}
                        subheader={t('views.redesignFile.selectTypeOfFiles')}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { md: 'column', xs: 'row' },
                          flexWrap: 'wrap',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <Button
                          onClick={() =>
                            setCurrentFilesQuery({
                              ...currentFilesQuery,
                              type: '',
                              page: 0,
                            })
                          }
                          startIcon={<FileCopyIcon />}
                        >
                          {t('views.redesignFile.all')}
                        </Button>
                        <Button
                          onClick={() =>
                            setCurrentFilesQuery({
                              ...currentFilesQuery,
                              type: 'images',
                              page: 0,
                            })
                          }
                          startIcon={<ImageIcon />}
                        >
                          {t('views.redesignFile.images')}
                        </Button>
                        <Button
                          onClick={() =>
                            setCurrentFilesQuery({
                              ...currentFilesQuery,
                              type: 'videos',
                              page: 0,
                            })
                          }
                          startIcon={<SlowMotionVideoIcon />}
                        >
                          {t('views.redesignFile.videos')}
                        </Button>
                        <Button
                          onClick={() =>
                            setCurrentFilesQuery({
                              ...currentFilesQuery,
                              type: 'apps',
                              page: 0,
                            })
                          }
                          startIcon={<AppRegistrationIcon />}
                        >
                          {t('views.redesignFile.apps')}
                        </Button>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              </Box>
            </Grid>
          </Container>
        </Box>
      </Layout>

      {/* modals */}

      <CreateWidgetModel
        isOpen={openWidget}
        onAddContent={fileUpload}
        onAddWidget={handleAddWidget}
        onTakeData={(data) => setData((prev) => [...prev, data])}
        onClose={() => setOpenWidget(false)}
        user={user}
      />

      <Dialog
        open={openPreviewContentModel}
        onClose={() => setOpenPreviewContentModel(false)}
        // maxWidth={previewContentUrl?.widget?.widgetCat == "weather" ? false : "lg"}
        fullScreen
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          {t('views.redesignFile.filePreview')}
        </DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: isMobile
                ? '70vw'
                : previewContentUrl?.widget?.widgetCat == 'weather'
                  ? '75vw'
                  : '50vw',
              height:
                previewContentUrl?.widget?.widgetCat == 'weather'
                  ? 'unset'
                  : '50vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '40px 0',
                gap: '10px 10px',
              }}
            >
              <Previewer previewContentUrl={previewContentUrl} />
              <Button
                variant={'outlined'}
                sx={{
                  height: '38px',
                  width: '193px',
                  textTransform: 'capitalize',
                  borderRadius: '10px',
                }}
                onClick={() => setOpenPreviewContentModel(false)}
              >
                {t('views.redesignFile.close')}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Place here RedesignPlayer modal */}

      <RedesignPlayer
        playlist={currentContentPreviewPlaylist || previewContentUrl}
        open={
          Boolean(currentContentPreview) || Boolean(previewContentUrl?.content)
        }
        onClose={() => {
          setCurrentContentPreview(null);
          setPreviewContentUrl(null);
        }}
        hideNav
      />

      {/* content preview model end */}

      <ConfirmationModel
        openCreateModel={openCreateModel}
        title={t('views.redesignFile.confirmDelete')}
        onClose={() => setOpenCreateModel(false)}
        onConfirm={onConfirm}
        Icon={DeleteIcon}
      />
      {/* <ConfirmationModel
        openCreateModel={openDeleteModel}
        title={t("views.redesignFile.confirmDelete")}
        onClose={() => setOpenDeleteModel(false)}
        onConfirm={onConfirmDeleteFile}
        Icon={DeleteIcon}
      /> */}

      <ConfirmDeleteDialog
        open={openDeleteModel}
        onClose={() => {
          setOpenDeleteModel(false);
          setDeleteIds([]);
        }}
        folders={deleteUsage.folders}
        onConfirm={onConfirmDeleteFile}
        playlists={deleteUsage.playlists}
        screens={deleteUsage.screens}
        fileCount={deleteIds.length}
      />

      <WidgetSyncScreensDialog
        open={widgetSyncPromptOpen}
        isSyncing={isSyncingWidgetScreens}
        onClose={() => dispatch(closeWidgetSyncPrompt())}
        onConfirm={async () => {
          setIsSyncingWidgetScreens(true);
          await dispatch(syncWidgetScreens(widgetSyncContentId));
          setIsSyncingWidgetScreens(false);
        }}
      />

      <Dialog
        open={openMoveModel}
        onClose={() => setOpenMoveModel(false)}
        maxWidth={'lg'}
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          {t('views.redesignFile.selectFolder')}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '40vw',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box style={{ width: '100px', height: '100px', margin: '0 auto' }}>
              <FolderIcon
                style={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            <Box sx={{ margin: '20px 0' }}>
              <Select
                value={folderVal}
                onChange={(e) => setFolderVal(e.target.value)}
                fullWidth
              >
                {[
                  {
                    _id: 'root',
                    name: t('views.redesignFile.home'),
                    folderFor: 'content',
                    path: [],
                    parent: '',
                  },
                  ...contentFolders,
                ].map((folders) =>
                  folders._id !== currentFolder ? (
                    <MenuItem value={folders._id}>{folders.name}</MenuItem>
                  ) : null,
                )}
              </Select>
            </Box>

            <DialogActions>
              <Button onClick={() => setOpenMoveModel(false)}>
                {t('views.redesignFile.close')}
              </Button>
              <Button onClick={moveOnFolder} variant={'contained'}>
                {t('views.redesignFile.save')}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openBulkMoveModel}
        onClose={() => setOpenBulkMoveModel(false)}
        maxWidth={'lg'}
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          {t('views.redesignFile.selectFolder')}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '40vw',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box style={{ width: '100px', height: '100px', margin: '0 auto' }}>
              <FolderIcon
                style={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            <Box sx={{ margin: '20px 0' }}>
              <Select
                value={folderVal}
                onChange={(e) => setFolderVal(e.target.value)}
                fullWidth
              >
                {[
                  {
                    _id: 'root',
                    name: t('views.redesignFile.home'),
                    folderFor: 'content',
                    path: [],
                    parent: '',
                  },
                  ...contentFolders,
                ].map((folders) => (
                  <MenuItem value={folders._id}>{folders.name}</MenuItem>
                ))}
              </Select>
            </Box>

            <DialogActions>
              <Button onClick={() => setOpenBulkMoveModel(false)}>
                {t('views.redesignFile.close')}
              </Button>
              <Button onClick={moveOnFolderBulk} variant={'contained'}>
                {t('views.redesignFile.save')}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>

      <YoutubeProcessingDialog
        open={ytPendingNames.length > 0}
        onClose={() => setYtPendingNames([])}
        names={ytPendingNames}
      />
      <Dialog
        open={openPlaylist}
        onClose={() => setOpenPlaylist(false)}
        maxWidth={'lg'}
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          {t('views.redesignFile.selectPlaylist')}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: '40vw',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box style={{ width: '100px', height: '100px', margin: '0 auto' }}>
              <FaList
                style={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            <Box sx={{ margin: '20px 0' }}>
              <Select
                value={playlistId}
                onChange={(e) => setPlaylistId(e.target.value)}
                fullWidth
              >
                {playlists.map((playlist) => (
                  <MenuItem value={playlist._id}>
                    {playlist.playlistName}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <DialogActions>
              <Button onClick={() => setOpenPlaylist(false)}>
                {t('views.redesignFile.close')}
              </Button>
              <Button onClick={addInPlaylist} variant={'contained'}>
                {t('views.redesignFile.save')}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>

      <AddContentModel
        browse={browse}
        onClose={(e) => setBrowse(e)}
        fileUpload={fileUpload}
        // fileUploadDragDrop={fileUploadDragDrop}
        onGoogleDrive={onGoogleDrive}
        onDropboxFiles={onDropboxFiles}
        onOneDrive={onOneDrive}
        reOpen={() => setBrowse(true)}
      />

      <Dialog
        open={openFolderEditModel}
        onClose={() => setOpenFolderEditModel(false)}
      >
        <FormControl component='form' onSubmit={(e) => e.preventDefault()}>
          <DialogTitle style={{ textAlign: 'center' }}>
            {t('views.redesignFile.editFolder')}
          </DialogTitle>
          <DialogContent style={{ borderRadius: '50px' }}>
            <Box
              sx={{
                display: 'flex',
                gap: '2px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                style={{ width: '300px', height: '50px', margin: '20px auto' }}
              >
                <TextField
                  required
                  type={'text'}
                  value={folderName}
                  onChange={(e) => setFolderName(e.target.value)}
                  fullWidth
                />
              </Box>
              <DialogActions>
                <Button onClick={() => setOpenFolderEditModel(false)}>
                  {t('views.redesignFile.cancel')}
                </Button>
                <Button
                  onClick={onConfirmFolderEdit}
                  variant={'contained'}
                  type='submit'
                >
                  {t('views.redesignFile.save')}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </FormControl>
      </Dialog>

      <Dialog
        open={isFoldersDialogOpen.open}
        onClose={() =>
          setIsFoldersDialogOpen({ ...isFoldersDialogOpen, open: false })
        }
      >
        <DialogTitle>Folders where the file is located</DialogTitle>
        <DialogContent
          sx={{
            maxHeight: '350px',
            overflowY: 'scroll',
          }}
        >
          <List>
            {isFoldersDialogOpen.folders.map((f) => {
              return (
                <ListItem key={f.id}>
                  <ListItemAvatar>
                    <Avatar>
                      <FolderOpenOutlinedIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${f.name.slice(0, 20)}${f.name.length > 20 ? '...' : ''}`}
                  />
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setIsFoldersDialogOpen({ ...isFoldersDialogOpen, open: false })
            }
          >
            {t('views.redesignFile.close')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isPlaylistsDialogOpen.open}
        onClose={() =>
          setIsPlaylistsDialogOpen({ ...isPlaylistsDialogOpen, open: false })
        }
      >
        <DialogTitle>Playlists in which the file is embedded</DialogTitle>
        <DialogContent
          sx={{
            maxHeight: '350px',
            overflowY: 'scroll',
          }}
        >
          {filteredFiles().find((f) => f.id == isPlaylistsDialogOpen.id)
            ?.playlists ? (
            filteredFiles().find((f) => f.id == isPlaylistsDialogOpen.id)
              ?.playlists.length > 0 ? (
              <List>
                {filteredFiles()
                  .find((f) => f.id == isPlaylistsDialogOpen.id)
                  .playlists.map((p) => {
                    return (
                      <ListItem key={p.id}>
                        <ListItemAvatar>
                          <Avatar>
                            <SubscriptionsIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={p.playlistName} />
                      </ListItem>
                    );
                  })}
              </List>
            ) : (
              <Typography>No playlist contains this file</Typography>
            )
          ) : (
            <Typography>No playlist contains this file</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setIsPlaylistsDialogOpen({
                ...isPlaylistsDialogOpen,
                open: false,
              })
            }
          >
            {t('views.redesignFile.close')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={contentDuplicateError}
        onClose={() => dispatch(closeContentDuplicateError())}
      >
        <DialogTitle style={{ textAlign: 'center' }}>
          {t('views.redesignFile.fileExist')}
        </DialogTitle>
        <DialogContent style={{ borderRadius: '50px' }}>
          <Box
            sx={{
              display: 'flex',
              gap: '2px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              style={{ width: '300px', height: '50px', margin: '20px auto' }}
            >
              <Typography
                variant='body1'
                sx={{
                  textAlign: 'center',
                }}
              >
                {t('views.redesignFile.fileExistReplace')}
              </Typography>
            </Box>
            <DialogActions>
              <Button onClick={() => dispatch(closeContentDuplicateError())}>
                {t('views.redesignFile.noClose')}
              </Button>
              <Button
                onClick={() => handleFileUpload(true)}
                variant={'contained'}
                type='submit'
              >
                {t('components.confirmationModel.yes')}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default RedesignFile;
